import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "800",
  height: "800",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-opacity": ".01",
      d: "M0 0h48v48H0z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "4",
      d: "M34 4h10v10m0 20v10H34m-20 0H4V34m0-20V4h10"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-width": "4",
      d: "M24 40c7.732 0 14-7.164 14-16S31.732 8 24 8s-14 7.163-14 16 6.268 16 14 16Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-width": "4",
      d: "M6 24.008 42 24M20.07 32.106Q21.97 33.51 24 33.51t4.038-1.405"
    }, null, -1)
  ])))
}
export default { render: render }